import {Component} from 'react';
import Button from 'react-bootstrap/Button';

class TextWithLearnMoreButton extends Component {
  constructor(props) {
    super(props);
     this.state={
        displayInfo: null
     }
     this.initializeDisplay();
  }

  initializeDisplay(){
        if (this.props.expandButtonText){
            this.expandButtonText = this.props.expandButtonText;
        }else{
            this.expandButtonText = "Learn More";
        }
        let displayInfo = true;
        if (this.props.initialStateCollapse === true){
            displayInfo = false;
        }
        this.textClass = "";
        if (this.props.text1Class){
            this.text1Class = this.props.text1Class;
        }
        if (this._isMounted === true){
            this.setState({displayInfo: displayInfo});
        }
  }
 
  toggleInfoDisplay = () => {
        if (this._isMounted === true){
            this.setState((prevState) => ({
            displayInfo: !prevState.displayInfo,
            }));
        }
    };

    render() {
     
    return <> 
       <div className="mx-3 text-left">
            <div className="mt-2">
            
            {this.state.displayInfo ?
                <>
                    <div className={this.text1Class}>{this.props.text1}</div>
                    <div className="mt-2">
                    <span> {this.props.text2} </span>
                        <Button
                            variant="outline-info"
                            size="sm"
                            onClick={this.toggleInfoDisplay}
                            style={{ display: 'inline-block' }}
                        >
                                Collapse
                        </Button>
                    </div>
                </>
            :
                <>
                    <span className={this.text1Class}>{this.props.text1}</span>
                    <span>
                        <Button
                            variant="outline-info"
                            size="sm"
                            onClick={this.toggleInfoDisplay}
                            style={{ display: 'inline-block' }} >
                            {this.expandButtonText}
                        </Button>
                    </span>
                </>
             
            }
        </div>
    </div>
    </>
}

componentDidMount(){
    this._isMounted = true;
}

}

export default TextWithLearnMoreButton;
